import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { InscricaoEtapaDto } from '@models/embate/clash-dto';
import { InscricaoChaveDto } from '@shared/services/competition/group-key.service';

@Component({
  selector: 'sigecom-roulette',
  templateUrl: './roulette.component.html',
})
export class RouletteComponent implements OnChanges, AfterViewInit {
  @Input() open = false;
  @Input() participant?: InscricaoChaveDto;
  @Input() isNational = false;
  @Output() animationEnded = new EventEmitter<boolean>();

  @ViewChild('track') track!: ElementRef<HTMLDivElement>;
  @ViewChild('container') container!: ElementRef<HTMLDivElement>;

  baseItems = Array.from({ length: 10 });

  drawArray: any[] = [];

  spinning = false;
  showCard = false;
  animationDuration = 5000;
  itemWidth = 0;

  ngAfterViewInit() {
    this.buildInfiniteArray();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open']) {
      if (changes['open'].currentValue) {
        this.reset();
        setTimeout(() => this.startSpin(), 10);
      } else {
        this.reset();
      }
    }

    if (changes['participant']) {
      this.reset();
      this.participant = changes['participant'].currentValue;
    }
  }

  buildInfiniteArray() {
    this.drawArray = [
      ...this.baseItems,
      ...this.baseItems,
      ...this.baseItems,
      ...this.baseItems,
      ...this.baseItems,
    ];
  }

  getDisplaySigla(): string {
    if (this.isNational) {
      if (this.participant?.ichBlSede) {
        return `1 - ${this.participant.estTxSigla ?? ''}`;
      }

      return this.participant?.estTxSigla ?? '';
    }

    return this.participant?.inscricaoEtapaDto?.ineObjInscricao?.incTxResumo ?? '';
  }

  getDisplayName(): string {
    if (this.isNational) {
      if (this.participant?.ichBlSede) {
        return `1 - ${this.participant.estTxNome ?? ''}`;
      }

      return this.participant?.estTxNome ?? '';
    }

    return this.participant?.inscricaoEtapaDto?.ineObjInscricao?.incTxResumo ?? '';
  }

  reset() {
    this.spinning = false;
    this.showCard = false;
    const trackEl = this.track?.nativeElement;
    if (!trackEl) return;

    trackEl.style.transition = 'none';
    trackEl.style.transform = 'translateX(0px)';
  }

  startSpin() {
    if (!this.track || !this.container) return;

    this.spinning = true;

    const trackEl = this.track.nativeElement;
    const containerEl = this.container.nativeElement;

    const firstItem = trackEl.children[0] as HTMLElement;

    this.itemWidth = firstItem.offsetWidth + 12; // gap-3

    const baseDistance = this.itemWidth * this.baseItems.length * 3;

    const containerCenter = containerEl.offsetWidth / 2;
    const itemCenter = this.itemWidth / 2;

    const finalPosition = baseDistance - containerCenter + itemCenter;

    trackEl.style.transition = `transform ${this.animationDuration}ms cubic-bezier(.08,.6,0,1)`;

    trackEl.style.transform = `translateX(-${finalPosition}px)`;

    setTimeout(() => {
      this.spinning = false;
      this.animationEnded.emit(true);
      this.showCard = true;
    }, this.animationDuration);
  }
}
